import { linePlot, maTypeInput, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";

/**
 * Moving Average (research §1.4): Period 10, type SMA / WMA / EMA / SMMA /
 * TMA of the close, formulas in math/movingAverages.js.
 */
export default {
  id: "moving-average",
  name: "Moving Average",
  isOscillator: false,
  inputs: [periodInput("period", "Period", 10, { max: 250 }), maTypeInput("type", "Type")],
  // As in PO: "Main Line", the first colour of the palette, 1 px
  plots: [linePlot("value", "Main Line", PALETTE.LIME)],
  levels: [],

  /**
   * @param {object[]} bars
   * @param {{ period: number, type: string }} inputs
   * @param {{ value: number[] }} series - values before `fromIndex` are already calculated
   * @param {number} fromIndex
   */
  calculate: (bars, { period, type }, series, fromIndex) => {
    fillMovingAverage({
      type,
      read: priceReader(bars, PRICE_SOURCE.CLOSE),
      target: series.value,
      period,
      fromIndex,
      toIndex: bars.length,
    });
  },
};
